import {AnyColumnJson, ColumnPredefinedOptionsJson} from "../api/json/ColumnJson"
import {ColumnType} from "../api/enum/ColumnType"
import {AnyTemplateJson} from "../api/json/TemplateJson"
import {TemplateType} from "../api/enum/TemplateType"

export default class ClassifierTemplateUtil {
    static readonly outputPattern = /^ ?\{\{([^{}]+)\}\}$/

    static outputClassColumn(template: AnyTemplateJson, columns: AnyColumnJson[]): ColumnPredefinedOptionsJson | null {
        const output = template.type === TemplateType.CHAT ? template.assistant : template.completion
        const match = (output ?? "").match(ClassifierTemplateUtil.outputPattern)
        if (!match) return null
        const column = columns.find(column => column.reference === match[1])
        return column?.type === ColumnType.PREDEFINED_OPTIONS ? column as ColumnPredefinedOptionsJson : null
    }

    static optionsColumns(columns: AnyColumnJson[]): AnyColumnJson[] {
        return columns.filter(column => column.type === ColumnType.PREDEFINED_OPTIONS)
    }

    static defaultOutput(columns: AnyColumnJson[]): string {
        const column = ClassifierTemplateUtil.optionsColumns(columns)[0]
        return column ? `{{${column.reference}}}` : ""
    }

    static validateOutput(output: string, columns: AnyColumnJson[]): string | null {
        if (ClassifierTemplateUtil.optionsColumns(columns).length === 0) {
            return "Classifier projects need a Predefined Options column to hold the classes. Add one, then set the Output to its {{reference}}."
        }
        const match = output.match(ClassifierTemplateUtil.outputPattern)
        if (!match) {
            return "A classifier template's Output must be exactly one {{reference}} to a Predefined Options column, with nothing else around it."
        }
        const column = columns.find(column => column.reference === match[1])
        if (!column || column.type !== ColumnType.PREDEFINED_OPTIONS) {
            return `The Output reference {{${match[1]}}} must point to a Predefined Options column.`
        }
        return null
    }
}
